
export interface IPoint{
    x: number,
    y: number
}
export const calcTopOfPath = (path : SVGPathElement) : SVGPoint =>{
    let point = {x:Number.MAX_SAFE_INTEGER,y:Number.MAX_SAFE_INTEGER} as SVGPoint;
    const length = path.getTotalLength();
    let steps = 0;
    let tempPoint


    while (length > steps){
        tempPoint= path.getPointAtLength(steps);
        if(point.y > tempPoint.y){
            point.x = tempPoint.x;
            point.y = tempPoint.y;
        }
        steps+=10;
    }
    return point;
}